package com.iptvplayer.shared.data.remote.api

import com.iptvplayer.shared.data.remote.dto.AdminReportsDto
import com.iptvplayer.shared.data.remote.dto.AdminUserDetailDto
import com.iptvplayer.shared.data.remote.dto.AdminUserDto
import com.iptvplayer.shared.data.remote.dto.SetDeletionRequestedRequestDto
import com.iptvplayer.shared.data.remote.dto.SetDisabledRequestDto
import com.iptvplayer.shared.util.Constants
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*

class AdminApi(private val client: HttpClient) {

    suspend fun getUsers(): List<AdminUserDto> =
        client.get("${Constants.BASE_URL}/api/admin/users").body()

    suspend fun getReports(): AdminReportsDto =
        client.get("${Constants.BASE_URL}/api/admin/reports").body()

    suspend fun getUserDetail(id: String): AdminUserDetailDto =
        client.get("${Constants.BASE_URL}/api/admin/users/$id").body()

    suspend fun setDisabled(id: String, disabled: Boolean) {
        client.put("${Constants.BASE_URL}/api/admin/users/$id/disabled") {
            contentType(ContentType.Application.Json)
            setBody(SetDisabledRequestDto(disabled))
        }
    }

    /** Reject (requested=false) or manually flag a user's deletion request. */
    suspend fun setDeletionRequested(id: String, requested: Boolean) {
        client.put("${Constants.BASE_URL}/api/admin/users/$id/deletion-request") {
            contentType(ContentType.Application.Json)
            setBody(SetDeletionRequestedRequestDto(requested))
        }
    }

    /** Approve a deletion request (or delete any user): permanent purge. */
    suspend fun deleteUser(id: String) {
        client.delete("${Constants.BASE_URL}/api/admin/users/$id")
    }
}
